import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RulerButton } from './RulerButton';
import { trackRulerClick } from './tracking';
import { Desktop } from '../../../../../../../packages/Responsive';
import { disableRuler, enableRuler } from '../../../../../actions';
import { selectIsRulerEnabled } from '../../../../../selectors';
import { useMapContext } from '../../../context';

export const RulerButtonContainer: React.FC = props => {
  const dispatch = useDispatch();
  const { map } = useMapContext();
  const isRulerEnabled = useSelector(selectIsRulerEnabled);

  const handleClick = React.useCallback(() => {
    if (!isRulerEnabled) {
      dispatch(enableRuler());
    } else {
      dispatch(disableRuler());
    }

    trackRulerClick();
  }, [dispatch, isRulerEnabled]);

  return (
    <Desktop>
      <RulerButton {...props} map={map} isRulerEnabled={isRulerEnabled} onClick={handleClick} />
    </Desktop>
  );
};
